import { Modal } from '@components/Element'
import I18n from '@utils/i18n';

const SafetTipModal = (props) => {
  const { bodyContenttype = '1' } = props
  const bodyContent = bodyContenttype === '1' ? I18n.t('24_tip') : I18n.t('changeMobile_tip')
  return (
      <Modal
        {...props}
        type='primary'
        title={I18n.t('tip')}
      >
          <span className='DINPro'>{bodyContent}</span>
      </Modal>
  )
}

export default SafetTipModal
